<ng-container *transloco="let t">
  <div class="main-content">
    <div class="data-section" id="data-section">
      <div class="title-row">
        <h3>{{ t(TITLE) }}</h3>
      </div>

      <div class="content-container">
        <div class="actions-row">
          <p-button
            [icon]="
              'pi pi-refresh' +
              (((dataLoading$ | async) ?? true) ? ' pi-spin' : '')
            "
            [disabled]="(dataLoading$ | async) ?? true"
            (click)="refreshData()"
          />

          <!-- <p-button
            icon="pi pi-filter"
            severity="info"
            [outlined]="!filtersDialogVisible"
            [disabled]="(dataLoading$ | async) ?? true"
            (click)="toggleFilters()"
            [label]="appliedFiltersCount"
          /> -->

          <input
            #dataSearch
            type="text"
            pInputText
            id="search-input"
            (input)="dataTable.filterGlobal(dataSearch.value, 'contains')"
            [placeholder]="t(SEARCH_PLACEHOLDER)"
            class="search-input"
          />

          <!-- <p-button
            [label]="t(ADD_BUTTON_LABEL)"
            icon="pi pi-plus"
            class="add-record-button"
            (click)="openFormDialog()"
          /> -->

          <p-button
            icon="pi pi-list-check"
            severity="secondary"
            [disabled]="selectedRows.length === 0"
            (click)="batchMenuElement.toggle($event)"
          />

          <p-menu
            #batchMenuElement
            [model]="batchMenu"
            [popup]="true"
            appendTo="body"
          />
        </div>

        <p-skeleton
          class="skeleton-loader"
          height="100%"
          width="100%"
          [class.visible]="(dataLoadingUI$ | async) ?? true"
        />

        <p-table
          #dataTable
          class="table"
          id="table"
          [value]="data"
          [(selection)]="selectedRows"
          [rowHover]="true"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
          sortMode="single"
          selectionMode="multiple"
          [rowTrackBy]="_dataTrackBy"
          [metaKeySelection]="true"
          [resizableColumns]="true"
          columnResizeMode="fit"
          [globalFilterFields]="dataFilterFields"
          stripedRows
          [scrollable]="true"
          [class.visible]="!((dataLoadingUI$ | async) ?? true)"
          sortField="creationTimestamp"
          [sortOrder]="-1"
        >
          <ng-template #header>
            <tr>
              <th style="width: 3rem"><p-tableHeaderCheckbox /></th>

              @for (col of columns; track col.field) {
                @if (col.visible ?? true) {
                  <th [pSortableColumn]="col.field" pResizableColumn>
                    <div class="table-header-row">
                      <span class="header-label">{{
                        t(col.header, col.headerParams)
                      }}</span>
                      <div class="header-buttons">
                        <p-sortIcon [field]="col.field" />
                      </div>
                    </div>
                  </th>
                }
              }
            </tr>
          </ng-template>
          <ng-template #body let-record let-rowIndex="rowIndex">
            <tr
              [pSelectableRow]="record"
              [pSelectableRowIndex]="rowIndex"
              (contextmenu)="$event.preventDefault(); openFormDialog(record)"
              (longPress)="openFormDialog(record)"
              appLongPress
            >
              <td (click)="$event.stopPropagation()">
                <p-tableCheckbox [value]="record" />
              </td>
              @for (col of columns; track col.field) {
                @if (col.visible ?? true) {
                  <td>
                    <!-- CELLA -->
                    @if (col.wrapper) {
                      <ng-container
                        *ngComponentOutlet="
                          col.wrapper;
                          inputs: parseWrapperInputs(col, [
                            record,
                            getCellData(col, record),
                          ])
                        "
                      ></ng-container>
                    } @else {
                      <span [innerHTML]="getCellData(col, record)"></span>
                    }
                  </td>
                }
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <!--? FORM DIALOG  --------------------------------->
  <p-dialog
    [header]="t('viewUserReport')"
    [modal]="true"
    [(visible)]="formDialogVisible"
    [style]="{ width: 'min(35rem, 90vw)' }"
    [maximizable]="false"
    [draggable]="false"
    appendTo="body"
    [focusOnShow]="true"
    [dismissableMask]="false"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="form-dialog"
  >
    <form class="dialog-form" #dialogForm="ngForm">
      <!--? ID ----------------------------->
      <p-floatlabel variant="in">
        <input
          #reportIdInput="ngModel"
          pInputText
          id="report-id-input"
          name="reportId"
          [ngModel]="formDialogData.reportId"
          autocomplete="off"
          required
          [disabled]="true"
        />
        <label for="report-id-input">
          {{ t("id") }}
        </label>
      </p-floatlabel>

      <!--? CATEGORY ----------------------------->
      <p-floatlabel variant="in">
        <input
          #reportCategoryInput="ngModel"
          pInputText
          id="report-category-input"
          name="reportCategory"
          [ngModel]="
            formDialogData.category
              ? t('userReports.' + formDialogData.category)
              : ''
          "
          autocomplete="off"
          required
          [disabled]="true"
        />
        <label for="report-category-input">
          {{ t("category") }}
        </label>
      </p-floatlabel>

      <!--? SECTION ----------------------------->
      <p-floatlabel variant="in">
        <input
          #reportSectionInput="ngModel"
          pInputText
          id="report-section-input"
          name="reportSection"
          [ngModel]="t(formDialogData.section ?? '%t%--')"
          autocomplete="off"
          required
          [disabled]="true"
        />
        <label for="report-section-input">
          {{ t("section") }}
        </label>
      </p-floatlabel>

      <!--? DETAILS ---------------------------------->
      <p-floatlabel variant="in">
        <textarea
          pTextarea
          #reportDetailsInput="ngModel"
          id="report-details-input"
          name="details"
          [ngModel]="formDialogData.details"
          autocomplete="off"
          [disabled]="true"
          styleClass="w-full"
          rows="4"
          style="resize: none"
        ></textarea>
        <label for="report-details-input">
          {{ t("details") }}
        </label>
      </p-floatlabel>

      <!--? USERNAME ----------------------------->
      <p-floatlabel variant="in">
        <input
          #reportUsernameInput="ngModel"
          pInputText
          id="report-username-input"
          name="reportUsername"
          [ngModel]="formDialogData.userIdDetails?.username ?? '--'"
          autocomplete="off"
          required
          [disabled]="true"
        />
        <label for="report-username-input">
          {{ t("username") }}
        </label>
      </p-floatlabel>

      <!--? TIMESTAMP ----------------------------->
      <p-floatlabel variant="in">
        <p-datepicker
          #reportTimestampInput="ngModel"
          inputId="report-timestamp-input"
          name="reportTimestamp"
          [ngModel]="formDialogData.creationTimestamp"
          autocomplete="off"
          required
          [disabled]="true"
          showIcon
          iconDisplay="input"
          [showTime]="true"
        />
        <label for="report-timestamp-input">
          {{ t("timestamp") }}
        </label>
      </p-floatlabel>
    </form>

    <ng-template #footer>
      <!-- @if (!isNewRecordDialog) { -->
      <p-button
        [label]="t('delete')"
        severity="danger"
        (click)="deleteRecord()"
        class="delete-button"
        [outlined]="true"
        [disabled]="(dataLoading$ | async) ?? true"
      />
      <!-- } -->

      <p-button
        [label]="t('showContext')"
        severity="primary"
        [outlined]="true"
        (click)="printReportContext()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('close')"
        severity="secondary"
        (click)="hideFormDialog()"
        [outlined]="true"
      />
      <!-- <p-button
        [label]="t('save')"
        severity="primary"
        (click)="saveRecord()"
        [disabled]="((dataLoading$ | async) ?? true) || !dialogForm.valid"
      /> -->
    </ng-template>
  </p-dialog>

  <!--? FILTERS DIALOG --------------------------------->
  <!--<p-dialog
    [header]="t(FILTERS_TITLE)"
    [(visible)]="filtersDialogVisible"
    [style]="{
      width: 'min(30rem, 80vw)',
      'min-width': '430px',
      'max-width': '90vw',
      'max-height': '90vh',
      'min-height': '10rem',
    }"
    [maximizable]="false"
    [draggable]="true"
    appendTo="body"
    styleClass="filter-dialog"
    (onHide)="onFiltersDialogHide()"
  >
    <form class="filter-form" #filterForm="ngForm"></form>

    <ng-template #footer>
      <p-button
        [label]="t('clear')"
        severity="danger"
        [outlined]="true"
        (click)="dataFilters.values = {}; refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="refreshData()"
        [disabled]="(dataLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>-->
</ng-container>
